import $ from 'jquery';

var selector = '.input input[type=text], .input input[type=email], .input input[type=password], .input input[type=tel], .input input[type=number], .input textarea'

$(document).on('blur', selector, function () {
    if ($(this).val() != "") {
        $(this).parent('.input').addClass('input--filled');
    } else {
        $(this).parent('.input').removeClass('input--filled');
    }
})

setTimeout(() => {
    $(selector).trigger('blur')
}, 100)


// WEBPACK FOOTER //
// ./nette/NetteFormFilled/index.js